module.exports = __webpack_public_path__ + "static/media/ico_report_action.d80f9ceb.svg";